var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2f42c2",
    height: "20px",
    width: "20px",
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10.35c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5S8.5,9.52,8.5,10.35z M12,8.85 c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S12.83,8.85,12,8.85z M17,8.85c-0.83,0-1.5,0.67-1.5,1.5 s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S17.83,8.85,17,8.85z M24,10.32c0,5.36-5.38,9.71-12,9.71c-1.06,0-2.11-0.11-3.12-0.33 l-6.59,3.69l1.84-5.73C1.5,15.82,0,13.18,0,10.32c0-5.36,5.38-9.71,12-9.71S24,4.96,24,10.32z M22,10.32c0-4.25-4.49-7.71-10-7.71 S2,6.07,2,10.32c0,2.38,1.4,4.59,3.84,6.07l0.67,0.41l-0.76,2.37l2.83-1.59l0.38,0.09c0.98,0.24,2,0.36,3.03,0.36 C17.51,18.03,22,14.57,22,10.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIconBlue);
export default __webpack_public_path__ + "static/media/messages_icon_blue.0c8b047613ea0a3f90814f064a8e0ea8.svg";
export { ForwardRef as ReactComponent };